import axios from "axios";
import { env } from "configs/EnvironmentConfig";
import { handlePut } from "redux/actions/baseAction";

export const SET_SAVINGS_SETTINGS = "SET_SAVINGS_SETTINGS";
export const SET_SAVINGS_SETTINGS_LOADING = "SET_SAVINGS_SETTINGS_LOADING";
export const SAVINGS_SETTINGS_SUCCESS = "SAVINGS_SETTINGS_SUCCESS";
export const SAVINGS_SETTINGS_RESET = "SAVINGS_SETTINGS_RESET";

export const setLoading = (load) => ({
  type: SET_SAVINGS_SETTINGS_LOADING,
  load,
});

export const setData = (data) => ({
  type: SET_SAVINGS_SETTINGS,
  data,
});

export const resetSavingsSettings = () => ({
  type: SAVINGS_SETTINGS_RESET,
});

export const getSavingsSettings = (force = false) => {
  return async (dispatch) => {
    dispatch(setLoading(true));

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${env.API}/core/admin/savings/savings-settings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Direct API Response:", response.data);

      const data = response.data;
      dispatch(setData(data));
      dispatch({ type: SAVINGS_SETTINGS_SUCCESS });
    } catch (error) {
      console.error("Error fetching settings:", error);
      dispatch(
        setData({
          principal_savings: 1000,
          mandatory_savings: 1000,
        }),
      );
    }

    dispatch(setLoading(false));
  };
};

export const updateSavingsSettings = (payload) => {
  return async (dispatch) => {
    dispatch(setLoading(true));

    return new Promise((resolve, reject) => {
      handlePut(
        "core/admin/savings/savings-settings",
        payload,
        (response, status) => {
          dispatch(setLoading(false));
          if (status && response) {
            dispatch(setData(response));
            resolve(response);
          } else {
            reject(response || { message: "Gagal menyimpan pengaturan" });
          }
        },
        true,
      );
    });
  };
};
